module.exports = __webpack_public_path__ + "media/img/horizontal-logo-small-397f3e54bf00ea4a4f69d152dea79733.png";